export default {
  ORIGINAL: 'ORIGINAL',
  DETACHED: 'DETACHED',
  FULL: 'FULL'
}
